import { ThumbDown, ThumbDownOutlined, ThumbUp, ThumbUpOutlined } from '@/shared/ui/icons';
import { ButtonBase } from '@/shared/ui/primitives/ButtonBase';

import { useRateAnswerTracking } from './useRateAnswerTracking';

type RateAnswerProps = {
  prompt: string;
  response: any[];
  conversationId: string;
  version: number;
  rating: -1 | 0 | 1 | undefined;
  onRate: (rating: -1 | 1) => void;
};

const iconProps = { width: '20px', height: '20px' };

const RateAnswer = ({
  prompt,
  response,
  conversationId,
  version,
  rating = 0,
  onRate
}: RateAnswerProps) => {
  const { track } = useRateAnswerTracking({ prompt, response, conversationId, version });

  return (
    <>
      <ButtonBase
        disableRipple
        data-testid='thumb-up'
        disabled={rating === 1}
        sx={{ '&.Mui-disabled': { opacity: 1 } }}
        onClick={() => {
          onRate(1);
          track(1);
        }}
      >
        {rating === 1 ? <ThumbUp sx={iconProps} /> : <ThumbUpOutlined sx={iconProps} />}
      </ButtonBase>
      <ButtonBase
        disableRipple
        data-testid='thumb-down'
        disabled={rating === -1}
        sx={{ '&.Mui-disabled': { opacity: 1 } }}
        onClick={() => {
          onRate(-1);
          track(-1);
        }}
      >
        {rating === -1 ? <ThumbDown sx={iconProps} /> : <ThumbDownOutlined sx={iconProps} />}
      </ButtonBase>
    </>
  );
};

export default RateAnswer;
